import React, { useState, useEffect } from "react";
import { uploadPreview, trivvyFileTypeCheck } from "../../../utils/constants";
import {
  BiCopy,
  BiLogoGoogle,
  BiLogoLinkedin,
  BiLogoMicrosoft,
  BiLogoMicrosoftTeams,
  BiLogoSlack,
  BiLogoWhatsapp,
  BiMailSend,
} from "react-icons/bi";
import ReactTooltip from "react-tooltip";
import {
  Button,
  Col,
  Row,
  FormGroup,
  Popover,
  PopoverHeader,
  PopoverBody,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import SlackSharePopup from "../../../components/SlackAndTeamsPopups/SlackSharePopup";
import TeamsSharePopup from "../../../components/SlackAndTeamsPopups/TeamsSharePopup";
import { baseUrl } from "../../../utils/constants";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import { toastContainer } from "../../../utils/toast";
import Select from "react-select/lib/Select";
import Tooltip from "../../../components/UI/TooltipIcon/TooptipIcon";
import { data } from "jquery";
import { getTriviaFileName, TRIVIA_LIB_PRIVACY_OPTIONS } from "../data";

export default function UpdateLibraryModal({
  open,
  onClose,
  onUpdateSuccess,
  libraryData,
  isToolkit = true,
  user,
}) {
  const [uploadedFile, setUploadedFile] = useState(null);
  const [privacy, setPrivacy] = useState(libraryData.status);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [usersData, setUsersData] = useState([]);
  const [updatedFields, setUpdatedFields] = useState({
    privacy: false,
    file: false,
  });

  const isAdmin = user && user.profile && user.profile.role && user.profile.role.toLocaleLowerCase() === 'admin';

  const privacyOptions = [
    ...TRIVIA_LIB_PRIVACY_OPTIONS.filter(opt => opt.value !== 'CUSTOM'),
    ...(isAdmin ? [{ label: "Only Admins", value: "ADMIN" }] : [])
  ];

  const formatSelectedUsers = (data) => {
    const d = data.map((e) => {
      if (e.firstName && e.lastName) {
        return {
          label: `${e.firstName}, ${e.lastName}`,
          value: e._id || e.userId,
        };
      } else if (e) {
        let name =
          e.firstName && e.firstName.length > 0 ? e.firstName : e.lastName && e.lastName.length > 0 ? e.lastName : e.email
        return { label: `${name}`, value: e._id || e.userId };
      }
    });

    return d;
  };

  const shouldEdit = () => {
    // Button is disabled if:
    // 1. No file is present
    if (!uploadedFile) return true;

    // 2. AND nothing has changed (neither file nor privacy)
    const isFileChanged = updatedFields.file;
    const isPrivacyChanged = privacy !== libraryData.status;

    return !(isFileChanged || isPrivacyChanged);
  };

  useEffect(() => {
    formatUrlToFile();
    if (libraryData.status === "CUSTOM") {
      if (libraryData.selectedUsers && libraryData.selectedUsers.length) {
        setSelectedUsers(formatSelectedUsers(libraryData.selectedUsers));
      }
    }
  }, []);

  const getUserList = () => {
    axios
      .get(url.userListArray)
      .then((response) => {
        setUsersData(response.data.data);
        const users = formatSelectedUsers(response.data.data);

        setUsersList(users);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getUserList();
  }, []);

  const fileSelectedHandler = (e) => {
    setUpdatedFields((prev) => ({ ...prev, file: true }));
    const file = e.target.files[0];
    // console.log('file: ', file)
    let obj = {
      name: file.name,
      type: file.type,
      size: file.size,
      file,
      datetime: Date.now().toString(),
      // blob: URL.createObjectURL(file),
      preview: URL.createObjectURL(file),
    };
    setUploadedFile(uploadPreview(obj));
  };

  const formatUrlToFile = () => {
    const ext = libraryData.s3Url ? libraryData.s3Url.split(".")[
      libraryData.s3Url.split(".").length - 1
    ] : "";
    let obj = {
      name: getTriviaFileName({
        uploadUrl: libraryData.s3Url,
        uploadedFileName: libraryData.fileUploadName,
        librarySourceType:libraryData.librarySourceType,
        libName:libraryData.name,
        webUrl:libraryData.webUrl

      }),
      type:
        ext === "pdf"
          ? { ext: "pdf", mime: "application/pdf" }
          : ["doc", "docx"].includes(ext)
          ? { ext: "doc", mime: "application/msword" }
          : ext === "txt"
          ? { ext: "txt", mime: "plain/text" }
          : null,
      size: null,
      file: null,

      preview: libraryData.s3Url,
    };
    setUploadedFile(uploadPreview(obj));
    setUpdatedFields({ ...updatedFields, file: false });
  };

  useEffect(() => {
    if (privacy === libraryData.status) {
      setUpdatedFields((prev) => ({ ...prev, privacy: false }));
    } else {
      setUpdatedFields((prev) => ({ ...prev, privacy: true }));
    }
  }, [privacy]);

  // Add drag and drop handlers
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    const files = e.dataTransfer.files;
    if (files && files.length > 0) {
      setUpdatedFields((prev) => ({ ...prev, file: true }));
      const file = files[0];
      if (trivvyFileTypeCheck(file.type)) {
        let obj = {
          name: file.name,
          type: file.type,
          size: file.size,
          file,
          datetime: Date.now().toString(),
          preview: URL.createObjectURL(file),
        };
        setUploadedFile(uploadPreview(obj));
      } else {
        toastContainer("Please upload Pdf or Doc or Txt file.", "error");
      }
    }
  };

  const handleOptionChange = (val) => {
    // console.log(changeEvent.target)
    // if (changeEvent.target.value === "ENTERPRISE") {
    //   setPrivacy("ENTERPRISE");
    // } else if (changeEvent.target.value === "CUSTOM") {
    //   setPrivacy("CUSTOM");
    // } else {
    //   setPrivacy("PRIVATE");
    // }
    setPrivacy(val.value);
  };

  const renderUploadPreview = () => {
    let photo = uploadedFile;
    let { preview, size, name } = photo;
    preview = preview != null && preview != undefined ? preview : photo.url;
    let mb = 1024 * 1024;
    let file_size =
      size >= mb
        ? `${(size / mb).toFixed(2)} MB`
        : `${(size / 1024).toFixed(2)} KB`;
    
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '16px',
          border: '1px solid #e5e7eb',
          borderRadius: '8px',
          backgroundColor: '#ffffff',
          marginBottom: '12px',
        }}
      >
        {/* PDF/File Icon */}
        <div
          style={{
            width: '48px',
            height: '48px',
            backgroundColor: '#dc2626',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: '12px',
            flexShrink: 0,
          }}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#ffffff"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
            <line x1="12" y1="18" x2="12" y2="12" />
            <line x1="9" y1="15" x2="15" y2="15" />
          </svg>
        </div>

        {/* File Name */}
        <div style={{ flex: 1, overflow: 'hidden' }}>
          <div
            style={{
              fontSize: '14px',
              fontWeight: '500',
              color: '#374151',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {name}
          </div>
          <div style={{ fontSize: '12px', color: '#9ca3af', marginTop: '2px' }}>
            {size ? file_size : ''}
          </div>
        </div>

        {/* Delete Icon */}
        <button
          onClick={(e) => {
            e.stopPropagation();
            setUploadedFile(null);
            setUpdatedFields((prev) => ({ ...prev, file: true }));
          }}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '8px',
            marginLeft: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#9ca3af"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="3 6 5 6 21 6" />
            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
            <line x1="10" y1="11" x2="10" y2="17" />
            <line x1="14" y1="11" x2="14" y2="17" />
          </svg>
        </button>
      </div>
    );
  };

  const callApiToSaveData = () => {
    const users_share = selectedUsers.map((itm) => {
      const user = usersData.find((x) => x._id == itm.value);

      if (user) {
        return {
          firstName: user.firstName,
          lastName: user.lastName,
          userId: user._id,
          date: new Date(),
          genderPronoun: user.genderPronoun,
          profilePic: user.profilePic,
        };
      } else {
        return {
          userId: itm.value,
          firstName: itm.label,
          lastName: "",
        };
      }
    });

    let payload = {};

    const triviaForm = new FormData();

    if (uploadedFile && updatedFields.file) {
      triviaForm.append("document", uploadedFile.file);
    }

    if (updatedFields.privacy) {
      payload = {
        selectedUsers: users_share,
        status: privacy,
      };
    }

    triviaForm.append("payload", JSON.stringify(payload));

    axios
      .put(url.updateTriviaLibraryDoc(libraryData._id), triviaForm)
      .then((res) => {
        const d = res.data.data;
        onUpdateSuccess(d);
        onClose();
      })
      .catch((err) => console.log(err));
  };
  return (
    <div>
      <style>
        {`
          .Select-control {
            background-color: #ffffff !important;
          }
        `}
      </style>
      <Modal isOpen={open} size="lg">
        <ModalHeader toggle={onClose}>
          <div>
            <div style={{ fontSize: '18px', fontWeight: '600', marginBottom: '4px' }}>
              Update Library
            </div>
          </div>
        </ModalHeader>
        <ModalBody className="p-3">
          <div className="mb-3">
             <div style={{ fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
               Document
             </div>
             {uploadedFile ? (
               <>
                 {renderUploadPreview()}
                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                   <div style={{ textAlign: 'left' }}>
                    <span
                      onClick={() => document.getElementById('profile-pic-file-input').click()}
                      style={{
                        fontSize: '14px',
                        color: '#3b82f6',
                        fontWeight: '500',
                        cursor: 'pointer',
                        textDecoration: 'none',
                      }}
                    >
                      Click here to upload a new file
                    </span>
                   </div>
                   <div style={{ textAlign: 'right' }}>
                    <span
                      onClick={() => {
                        formatUrlToFile();
                      }}
                      style={{
                        fontSize: '13px',
                        color: '#6b7280',
                        cursor: 'pointer',
                        textDecoration: 'underline'
                      }}
                    >
                      Keep Original
                    </span>
                   </div>
                 </div>
               </>
             ) : (
                <div
                  style={{
                    border: '2px dashed #d1d5db',
                    borderRadius: '8px',
                    padding: '32px 20px',
                    textAlign: 'center',
                    backgroundColor: '#f9fafb',
                    cursor: 'pointer',
                  }}
                  onClick={() => document.getElementById('profile-pic-file-input').click()}
                  onDragOver={handleDragOver}
                  onDragEnter={handleDragEnter}
                  onDragLeave={handleDragLeave}
                  onDrop={handleDrop}
                >
                  <div style={{ marginBottom: '8px' }}>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#3b82f6"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      style={{ margin: '0 auto' }}
                    >
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                      <polyline points="17 8 12 3 7 8" />
                      <line x1="12" y1="3" x2="12" y2="15" />
                    </svg>
                  </div>
                  <div style={{ fontSize: '14px', color: '#374151', marginBottom: '4px' }}>
                    Drop your file here, or{' '}
                    <span
                      style={{
                        color: '#3b82f6',
                        fontWeight: '500',
                        cursor: 'pointer',
                        textDecoration: 'underline',
                      }}
                    >
                      browse
                    </span>
                  </div>
                  <div style={{ fontSize: '12px', color: '#9ca3af' }}>
                    PDF, DOC, or TXT up to 10MB
                  </div>
                </div>
             )}
             
             <input
                id="profile-pic-file-input"
                onChange={fileSelectedHandler}
                type="file"
                accept=".doc,.DOC,.docx,.DOCX,.pdf,.PDF,.txt"
                style={{ display: 'none' }}
              />
          </div>

          <div className="mb-3">
             <div style={{ fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
               Privacy
             </div>
             <Select
                value={privacyOptions.find(opt => opt.value === privacy)}
                onChange={(val) => {
                  handleOptionChange(val);
                }}
                options={privacyOptions}
                placeholder="Select Privacy"
                styles={{
                  control: (base) => ({
                    ...base,
                    fontSize: '14px',
                    padding: '2px',
                    borderRadius: '6px',
                    border: '1px solid #d1d5db',
                    backgroundColor: '#ffffff',
                  }),
                }}
              />

              {privacy === "CUSTOM" && (
                <div className="mt-3">
                  <Select
                    isMulti={true}
                    multi={true}
                    name="user-select"
                    placeholder={"Select users to share this quiz with"}
                    value={
                      selectedUsers && selectedUsers.length > 0
                        ? selectedUsers
                        : ""
                    }
                    options={usersList}
                    onChange={(itm) => setSelectedUsers(itm)}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    styles={{
                      control: (base) => ({
                        ...base,
                        fontSize: '14px',
                        borderRadius: '6px',
                        border: '1px solid #d1d5db',
                        backgroundColor: '#ffffff',
                      }),
                    }}
                  />
                </div>
              )}
          </div>
        </ModalBody>
        <ModalFooter style={{ borderTop: '1px solid #e5e7eb', padding: '12px 20px' }}>
          <Button
            color="link"
            onClick={onClose}
            style={{
              fontSize: '14px',
              fontWeight: '500',
              padding: '10px 20px',
              borderRadius: '6px',
              border: 'none',
              backgroundColor: 'transparent',
              color: '#6b7280',
              textDecoration: 'none',
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={callApiToSaveData}
            disabled={shouldEdit()}
            style={{
              fontSize: '14px',
              fontWeight: '500',
              padding: '10px 20px',
              borderRadius: '6px',
              backgroundColor: '#1062fe',
              border: 'none',
              color: '#ffffff',
            }}
          >
            Update
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}
